export default __webpack_public_path__ + "static/media/paper.94a699f9.svg";